import paramUtil from '@/utils/param';

export const APPID = {
  WECHAT: {
    PLATFORM: 'wxb937e3d0b3ca117e', // 平台小程序
    PH: 'wxda591e289442a50d', // 普惠小程序
    HITCH: 'wx5b8f2b678eb20a9b', // 顺风车独立小程序
    DRIVER: 'wxabfd42781cb9dd96', // 顺风车车主
  },
  ALIPAY: {
    PLATFORM: '2017050407110255', // 平台小程序
    PH: '2021001185685229', // 普惠小程序
    HITCH: '2021003118621311', // 顺风车独立小程序
    DRIVER: '2021003113666629', // 顺风车车主
  },
};

/**
 * 获取所在端口
 */
export const getMPPort = () => {
  const appId = paramUtil.get('appId', window.location.href);
  if (appId) {
    const IS_PLATFORM = appId === APPID.WECHAT.PLATFORM || appId === APPID.ALIPAY.PLATFORM;
    const IS_HITCH_INDEP = appId === APPID.WECHAT.HITCH || appId === APPID.ALIPAY.HITCH;
    const IS_DRIVER_APPLY_MP = appId === APPID.WECHAT.DRIVER || appId === APPID.ALIPAY.DRIVER;
    const IS_PH = appId === APPID.WECHAT.PH || appId === APPID.ALIPAY.PH
      || (!IS_PLATFORM && !IS_HITCH_INDEP && !IS_DRIVER_APPLY_MP); // 如果都没匹配到，则使用普惠小程序兜底
    return {
      IS_PLATFORM,
      IS_HITCH_INDEP,
      IS_DRIVER_APPLY_MP,
      IS_PH,
    };
  }
  // 如果url上没有获取到，则使用平台小程序兜底
  return { IS_PLATFORM: true };
};

export default {
  getMPPort,
};
